module.exports = __webpack_public_path__ + "media/phase-6-vyl-complete.3e70f185.mp4";